import { uriToResource } from 'jwt-cert-sdk';

export const uriToResourceId = (uri: string): string => uriToResource(uri).resourceId;
